import { Pipe, PipeTransform } from '@angular/core';
import { IconName, faFileImage, faFilePdf, faFile } from '@fortawesome/free-regular-svg-icons';

@Pipe({
  name: 'mimeTypeIcon'
})
export class MimeTypeIcon implements PipeTransform {

  private faFileImage = faFileImage;
  private faFilePdf = faFilePdf;
  private faFile = faFile;

  public transform(value: any): IconName {
    return this.getIcon(value.toString()) as IconName;
  }

  private getIcon(value: string): string {
    const mimeType = value.split('/');

    if (mimeType.length === 2) {
      if (mimeType[0] === 'image') { return 'file-image'; }
      if (mimeType[0] === 'application') {
        if (mimeType[1] === 'pdf') { return 'file-pdf'; }
      }
    }

    return 'file';
  }

}
